<template>
  <div class="uk-container">
    <user-create :type="3" :dentist="$route.params.id" />
  </div>
</template>

<script>
import UserCreate from '@/components/user/Create.vue'

export default {
  name: 'ViewDentistUserCreate',

  components: { UserCreate }
}
</script>
